import React, { useState } from "react";

const OnboardingStep2 = ({ activeItems, toggleSubMenu, handleNext }) => {
  const [age, setAge] = useState("");

  const isActive = (item) => activeItems.includes(item);
  const [errorMessage, setErrorMessage] = useState("");

  const handleToggle = (group, item) => {
    const groupItems =
      group === "step2-1"
        ? ["step2-2", "step2-3"]
        : ["step2-5", "step2-6", "step2-7", "step2-8"];
    groupItems.forEach((activeItem) => {
      if (isActive(activeItem)) toggleSubMenu(activeItem);
    });
    toggleSubMenu(item);
  };

  const options = {
    knee: {
      "step2-2": "Left",
      "step2-3": "Right",
    },
    gender: {
      "step2-5": "Male",
      "step2-6": "Female",
      "step2-7": "Non-binary",
      "step2-8": "Prefer not to say",
    },
  };

  const handleNextWithStorage = () => {
    const whichKnee = Object.keys(options.knee).find(isActive);
    const gender = Object.keys(options.gender).find(isActive);

    if (whichKnee) localStorage.setItem("which_knee", options.knee[whichKnee]);
    if (gender) localStorage.setItem("gender", options.gender[gender]);
    if (age) localStorage.setItem("age", age);

    handleNext();
  };

  const isNextButtonVisible = () => {
    const whichKnee = Object.keys(options.knee).find(isActive);
    const gender = Object.keys(options.gender).find(isActive);

    return whichKnee && gender && age;
  };

  return (
    <div className="modal-container animated-onboarding onboarding-step2 fadeIn">
      <div className="modal-container-title fade1 heading">
        Just a few more details to make this journey yours.
      </div>
      <div className="modal-contect-title label fade2">
        1. Which knee is affected?
      </div>
      <ul className="selection selection-flex selection-ico fade2">
        {Object.keys(options.knee).map((item, index) => (
          <li
            key={item}
            className={`ico ${item === "step2-2" ? "ico-left" : "ico-right"} ${
              isActive(item) ? "active" : ""
            }`}
            onClick={() => handleToggle("step2-1", item)}
          >
            {options.knee[item]}
          </li>
        ))}
      </ul>
      {Object.keys(options.knee).some(isActive) && (
        <div className="step-container fadeInDown">
          <div className="modal-contect-title label">
            2. How do you identify?
          </div>
          <ul className="selection selection-flex">
            {Object.keys(options.gender).map((item, index) => (
              <li
                key={item}
                className={isActive(item) ? "active" : ""}
                onClick={() => handleToggle("step2-2", item)}
              >
                {options.gender[item]}
              </li>
            ))}
          </ul>
        </div>
      )}
      {Object.keys(options.gender).some(isActive) && (
        <div className="step-container custom-age">
          <div className="modal-contect-title label">3. Age</div>
          <input
            type="number"
            className="input-age"
            value={age}
            min="1"
            max="150"
            onChange={(e) => {
              const value = e.target.value;
              if (
                value === "" ||
                (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 150)
              ) {
                setAge(value);
                setErrorMessage(""); // Clear error message
              } else if (parseInt(value, 10) > 150) {
                setErrorMessage("Oops—your age doesn’t look quite right.");
              }
            }}
          />
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      )}

      {isNextButtonVisible() && (
        <>
          <div className="nav-container fade-fast">
            <button
              className="btn-next next-btn"
              onClick={handleNextWithStorage}
            >
              Next
            </button>
          </div>
          <div className="dot-container fade-fast">
            <div className="dot-unchecked"></div>
            <div className="dot-checked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default OnboardingStep2;
